export enum AutomationType {
  TrafficTarget = 'traffic-target',
  DateStart = 'date-start',
  DateEnd = 'date-end'
}

export const AutomationTypesLabels: Record<AutomationType, string> = {
  [AutomationType.TrafficTarget]: 'Traffic Target',
  [AutomationType.DateStart]: 'Date Start',
  [AutomationType.DateEnd]: 'Date End'
};

export enum TargetWindow {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Quartile = 'quartile'
}

export enum AutomationEntityType {
  Task = 'task',
  DealRelation = 'deal-relation'
}

export interface TrafficTargetParams {
  target: number;
  window: TargetWindow;
}
export interface DateParams {
  at: string; // ISO string
}
export interface TrafficBalanceParams {
  // extend later if needed
}

export type AutomationParams = TrafficTargetParams | DateParams | TrafficBalanceParams;

export type AutomationRequest =
  | { id: number; type: AutomationType.TrafficTarget; params: TrafficTargetParams }
  | { id: number; type: AutomationType.DateStart; params: DateParams }
  | { id: number; type: AutomationType.DateEnd; params: DateParams };
